module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Group Posts\n    ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_filter,
      "label": "Status",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.currentStatus),
      callback: function($$v) {
        _vm.currentStatus = $$v
      },
      expression: "currentStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.default_filter,
      "label": "Date Range",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.feeds,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(_vm._f("actualDate")(props.item.posteddate)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_c('div', {
          staticClass: "avatar ml-2 mr-2",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [_c('img', {
          attrs: {
            "src": props.item.avatar,
            "alt": _vm.returnName(props.item.user.firstname)
          }
        })]), _vm._v("\n          " + _vm._s(_vm.returnName(props.item.user)) + "\n        ")]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(props.item.user.company.companylegalname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sliceText")(props.item.content)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(_vm._f("status")(props.item.approvalStatus)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 1,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(1, ((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "disabled": props.item.approvalStatus === 2,
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changeStatus(2, ((props.item.groupId) + "/" + (props.item.id)))
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": "",
            "width": "790px"
          },
          model: {
            value: (props.item.activeDialog),
            callback: function($$v) {
              _vm.$set(props.item, "activeDialog", $$v)
            },
            expression: "props.item.activeDialog"
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-card', [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs12": "",
            "sm12": ""
          }
        }, [_c('v-card', [_c('v-toolbar', {
          attrs: {
            "card": "",
            "color": "white",
            "prominent": ""
          }
        }, [_c('v-toolbar-title', {
          staticClass: "body-2 grey--text"
        }, [_vm._v("Post Details")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text darken-1",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              props.item.activeDialog = false
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
          staticClass: "pa-3",
          attrs: {
            "two-line": "",
            "dense": ""
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(props.item.user.firstname + ' ' + props.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(props.item.user.jobtitle) + " "), (props.item.user.jobtitle) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" " + _vm._s(props.item.user.company.companylegalname))])], 1)], 1), _vm._v(" "), _c('v-card-text', {
          staticStyle: {
            "height": "100px"
          }
        }, [_vm._v(_vm._s(props.item.content))]), _vm._v(" "), _c('v-divider', {
          staticClass: "mt-0 px-2"
        }), _vm._v(" "), _c('v-card', {
          staticClass: "pa-3"
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [(props.item.video) ? _c('v-flex', {
          class: {
            'xs12': true, 'md6': props.item.video && props.item.attatchmentUrl, 'md12': props.item.video && !props.item.attatchmentUrl
          }
        }, [_c('iframe', {
          staticStyle: {
            "width": "100%",
            "height": "260px",
            "border": "0px"
          },
          attrs: {
            "allowfullscreen": "",
            "src": props.item.video.embedUrl
          }
        })]) : _vm._e(), _vm._v(" "), (props.item.attatchmentUrl) ? _c('v-flex', {
          staticClass: "background-image",
          class: {
            'xs12': true, 'md6': props.item.attatchmentUrl && props.item.video, 'md12': props.item.attatchmentUrl && !props.item.video
          },
          style: ({
            'backgroundImage': ("url(" + (props.item.attatchmentUrl) + ")")
          })
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "lazy": "",
            "absolute": "",
            "width": "500px"
          },
          model: {
            value: (_vm.dialog),
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.assignId(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
          staticClass: "headline"
        }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete '" + _vm._s(_vm._f("sliceText")(props.item.content)) + "'?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              _vm.dialog = false
            }
          }
        }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text darken-1",
          attrs: {
            "flat": "flat"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteRow()
            }
          }
        }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)])]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n    ")]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5de43b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Request/groupposts.vue
// module id = 1234
// module chunks = 3 4